import { render, staticRenderFns } from "./KUpload.vue?vue&type=template&id=e808725a&scoped=true&lang=pug"
import script from "./KUpload.vue?vue&type=script&lang=js"
export * from "./KUpload.vue?vue&type=script&lang=js"
import style0 from "./KUpload.vue?vue&type=style&index=0&id=e808725a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e808725a",
  null
  
)

export default component.exports